import integration from "../../../store/modules/integration";

const enHausefulUsers = {
  hausefulUsers: {
    label: {
      name: 'Name',
      email: 'Email',
      document: 'CPF',
      userType: 'User Type',
      rg: 'ID',
      phone: 'Phone',
      birthDate: 'Birth Date',
      password: 'Password',
      repeatPassword: 'Repeat Password',
      isUserTester: 'Test User?',
      isActive: 'Active',
      active: 'Active',
      deletedAt: 'Removed on {date}',
      services: 'Services',
      city: 'City',
      type: 'Type',
      yes: 'Yes',
      no: 'No',
      realEstate: 'Real Estate',
      branch: 'Branch',
      integration: 'Integration',
      status: 'Status',
      location: 'Location',
      information: 'Information',
      activeServices: 'Active services',
    },

    action: {
      save: 'Save user',
      edit: 'Update user',
      cancel: 'Cancel',
      create: 'Create user',
      delete: 'Delete user',
      loading: 'Loading',
      details: 'Details',
      checklistLink: 'Link with Checklist app',
    },

    hints: {
      delete: 'Do you really want to remove this user?',
    },

    messages: {
      successfullyCreated: 'User created successfully',
      successfullyEdited: 'User edited successfully',
      successfullyDeleted: 'User removed successfully',
      noServiceTypesSelected: 'No service types selected',
      selectServiceTypes: 'Select service types',
      noActiveServiceTypes: 'No active service types',
      allServiceTypesSelected: 'All service types selected',
    },
  },
};

export default enHausefulUsers;
